import { useState, useEffect } from 'react';

const posts = [
  {
    id: 1,
    image: 'https://static.readdy.ai/image/7c1e788bcb66949f87d807c4f125e261/f486bef0e3e16c1f186f8029dfd18a6d.png',
    link: 'https://www.instagram.com/p/DQxMrV6kduq/',
    category: 'Saúde Íntima',
    title: 'Clareamento Íntimo',
  },
  {
    id: 2,
    image: 'https://static.readdy.ai/image/7c1e788bcb66949f87d807c4f125e261/e9190afd67c031e968688c7e28cecc5b.png',
    link: 'https://www.instagram.com/p/DR2RVoIEaWj/?img_index=1',
    category: 'Procedimento',
    title: 'Ninfoplastia',
  },
  {
    id: 3,
    image: 'https://static.readdy.ai/image/7c1e788bcb66949f87d807c4f125e261/70ff636346152510c3fb87d96a8db5bb.png',
    link: 'https://www.instagram.com/p/DTS3HKtkUTB/?img_index=1',
    category: 'Saúde Feminina',
    title: 'Ressecamento Vaginal',
  },
  {
    id: 4,
    image: 'https://static.readdy.ai/image/7c1e788bcb66949f87d807c4f125e261/f369a22cbfc232cda024b69d19d29a6d.png',
    link: 'https://www.instagram.com/p/DTsk_o1kXqr/',
    category: 'Depoimento',
    title: 'Feedback de Paciente',
  },
  {
    id: 5,
    image: 'https://static.readdy.ai/image/7c1e788bcb66949f87d807c4f125e261/a3497e13db2a7b11f360ca3127ce0ef2.png',
    link: 'https://www.instagram.com/p/DQ6l9MREf1h/?img_index=1',
    category: 'Estética',
    title: 'Sobre Injetáveis',
  },
  {
    id: 6,
    image: 'https://static.readdy.ai/image/7c1e788bcb66949f87d807c4f125e261/127e76a3c2008c347d8a6843d4195011.png',
    link: 'https://www.instagram.com/p/DYo_xIsETJc/?img_index=1',
    category: 'Evento',
    title: 'My Paus',
  },
];

export default function InstagramSection() {
  const [, setActivePost] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActivePost((prev) => (prev + 1) % posts.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="conteudos" data-cascade className="relative w-full py-28 md:py-44 bg-offwhite paper-texture overflow-hidden">
      {/* Editorial background blurs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[5%] right-[-5%] w-[35%] h-[45%] rounded-full bg-rose-light/6 blur-[140px]" />
        <div className="absolute bottom-[5%] left-[-5%] w-[30%] h-[40%] rounded-full bg-sage-light/5 blur-[100px]" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16 md:mb-24 max-w-2xl mx-auto">
          <p data-cascade-label className="font-body text-[10px] md:text-[11px] text-secondary-500 tracking-[0.4em] uppercase mb-3">
            Conteúdos & Instagram
          </p>
          <div data-cascade-line className="w-12 h-[1px] bg-gold-matte/40 mx-auto mb-4" />
          <h2 data-cascade-title className="font-heading text-2xl md:text-3xl lg:text-4xl text-graphite font-light leading-[1.2] mb-4">
            Informação de confiança para cuidar da sua saúde em{' '}
            <span className="italic">todas as fases da vida</span>.
          </h2>
          <p data-cascade-text className="font-body text-sm text-graphite/45 font-light leading-relaxed">
            Acompanhe conteúdos produzidos pela Dra. Nathália com orientações baseadas em ciência, acolhimento e prevenção.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
          {/* Left: Premium phone mockup with Reels video */}
          <div data-cascade-image className="w-full lg:w-[38%] flex justify-center">
            <div className="relative">
              {/* Phone frame */}
              <div className="w-[250px] h-[510px] md:w-[270px] md:h-[550px] bg-black rounded-[2.5rem] border-[5px] border-secondary-200/50 shadow-[0_20px_70px_rgba(0,0,0,0.03)] overflow-hidden relative">
                {/* Reels video — full screen, no UI chrome */}
                <video
                  src="https://res.cloudinary.com/nar2q9cc/video/upload/v1785613205/ATUAL_NATHALIA_tjujjn.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="absolute inset-0 w-full h-full object-cover"
                />

                {/* Reels right-side actions overlay */}
                <div className="absolute right-3 bottom-20 flex flex-col items-center gap-5 z-10">
                  <button className="flex flex-col items-center gap-1 group">
                    <i className="ri-heart-line text-white text-lg group-hover:scale-110 transition-transform duration-200" />
                    <span className="font-body text-[9px] text-white/80">12.4k</span>
                  </button>
                  <button className="flex flex-col items-center gap-1 group">
                    <i className="ri-chat-1-line text-white text-lg group-hover:scale-110 transition-transform duration-200" />
                    <span className="font-body text-[9px] text-white/80">847</span>
                  </button>
                  <button className="flex flex-col items-center gap-1 group">
                    <i className="ri-send-plane-line text-white text-lg group-hover:scale-110 transition-transform duration-200" />
                  </button>
                  <button className="flex flex-col items-center gap-1 group mt-1">
                    <i className="ri-more-line text-white text-lg group-hover:scale-110 transition-transform duration-200" />
                  </button>
                </div>

                {/* Reels bottom info overlay */}
                <div className="absolute bottom-4 left-4 right-14 z-10">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-rose-light to-sage-light border border-white/30 flex-shrink-0" />
                    <p className="font-body text-[11px] text-white font-medium">dranathaliaposso</p>
                    <button className="font-body text-[10px] text-white font-semibold border border-white/40 rounded-full px-3 py-1 ml-auto hover:bg-white/10 transition-colors duration-200 whitespace-nowrap">
                      Seguir
                    </button>
                  </div>
                  <p className="font-body text-[10px] text-white/90 leading-relaxed font-light">
                    <span className="font-semibold">dranathaliaposso</span>{' '}
                    Cuidar da sua saúde íntima é um ato de amor próprio. Agende sua consulta 💫
                  </p>
                </div>
              </div>

              {/* Phone shadow */}
              <div className="absolute -bottom-6 -left-6 -right-6 h-10 bg-foreground-100/20 blur-3xl rounded-full -z-10" />
            </div>
          </div>

          {/* Right: Editorial magazine grid */}
          <div className="w-full lg:w-[62%]">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
              {posts.map((post) => (
                <a
                  key={post.id}
                  href={post.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-slide-in
                  data-slide-direction="right"
                  className="group relative bg-white/80 border border-white/60 overflow-hidden transition-all duration-500 hover:border-gold-matte/15 hover:scale-[1.03] hover:shadow-[0_10px_40px_rgba(0,0,0,0.04)]"
                >
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-600 group-hover:scale-105"
                    />
                  </div>

                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-graphite/15 opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center backdrop-blur-[1px]">
                    <span className="font-body text-[10px] text-white font-medium tracking-[0.15em] uppercase flex items-center gap-1.5">
                      <i className="ri-instagram-line text-sm" />
                      Ver no Instagram
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16 md:mt-24">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 md:w-16 h-[1px] bg-gold-matte/15" />
            <div className="w-1.5 h-1.5 rounded-full bg-gold-matte/20" />
            <div className="w-12 md:w-16 h-[1px] bg-gold-matte/15" />
          </div>
          <p className="font-heading text-lg md:text-xl text-graphite/55 font-light italic mb-6">
            Acompanhe mais conteúdos sobre saúde feminina.
          </p>
          <a
            href="https://instagram.com/dranathaliaposso"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-breathe inline-flex items-center gap-2 font-body text-xs font-semibold text-white bg-graphite hover:bg-graphite/85 hover:scale-[1.02] px-10 py-4 tracking-[0.12em] uppercase transition-all duration-500 whitespace-nowrap"
          >
            <i className="ri-instagram-line" />
            Seguir no Instagram
          </a>
        </div>
      </div>
    </section>
  );
}